import React from 'react';

export function CashGiftGuideStyles() {
  return (
    <style>{`
    .refer-earn-cash-gift-visual {
      transform-origin: 50% 82%;
    }
    .refer-earn-cash-gift-visual > img,
    .refer-earn-cash-gift-effects-layer {
      transition-property: opacity, filter;
      transition-duration: 180ms;
      transition-timing-function: ease-out;
    }
    .refer-earn-cash-gift-guide-obscured > img,
    .refer-earn-cash-gift-guide-obscured > .refer-earn-cash-gift-effects-layer {
      opacity: 0.58;
      filter: saturate(0.42) brightness(1.08) contrast(0.88);
    }
    .refer-earn-cash-gift-guide-releasing > img,
    .refer-earn-cash-gift-guide-releasing > .refer-earn-cash-gift-effects-layer {
      opacity: 1;
      filter: saturate(1) brightness(1) contrast(1);
      transition-delay: 0ms;
      transition-duration: 320ms;
      transition-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
    }
    .refer-earn-cash-gift-idle-settling {
      animation: none;
      transform: none;
      transition: transform 120ms ease-out;
      will-change: transform;
    }
    .refer-earn-cash-gift-effects-layer,
    .refer-earn-cash-gift-guide {
      opacity: 1;
      transition-property: opacity, transform;
      transition-timing-function: ease-out;
    }
    .refer-earn-cash-gift-effects-dismissing {
      opacity: 0;
    }
    .refer-earn-cash-gift-effects-dismissing *,
    .refer-earn-cash-gift-effects-dismissing *::before,
    .refer-earn-cash-gift-effects-dismissing *::after {
      animation-play-state: paused;
    }
    .refer-earn-cash-gift-guide-dismissing {
      opacity: 0;
      transform: translate(-50%, -50%) scale(1.35);
    }
  `}</style>
  );
}
